import {createFileRoute} from '@tanstack/react-router';

import PaymentOrderPay from '@/patient/views/payments/PaymentOrderPay';

export const Route = createFileRoute('/(patient)/patient/payment-orders/$paymentOrderId/pay')({
  component: PaymentOrderPay
});
